import { useEffect, useState } from 'react';

/**
 * Current page URL, or `null` on the first render — the location is read in an
 * effect, so it is only available after mount.
 *
 * Replaces the `nextjs-current-url` package, which declared a hard dependency on
 * `next` (pulling the whole Next.js runtime, and its security advisories, into
 * this CRA app) even though only its unused `/server` entry point needed it.
 */
const useUrl = (): URL | null => {
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  return currentUrl ? new URL(currentUrl) : null;
};

export default useUrl;
